import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeletePlayerInput3nqh5he11jo1p as DeletePlayerInput } from '../DeletePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePlayerInput_InputAdapterClass;
function DeletePlayerInput_InputAdapter() {
  if (DeletePlayerInput_InputAdapterClass === VOID) {
    class $ {
      p40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      k6x(writer, customScalarAdapters, value) {
        writer.l4d('partyId');
        get_partyIdAdapter().q40(writer, customScalarAdapters, value.y6t_1);
        writer.l4d('playerId');
        get_playerIdAdapter().q40(writer, customScalarAdapters, value.z6t_1);
      }
      q40(writer, customScalarAdapters, value) {
        return this.k6x(writer, customScalarAdapters, value instanceof DeletePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DeletePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    DeletePlayerInput_InputAdapterClass = $;
  }
  return DeletePlayerInput_InputAdapterClass;
}
var DeletePlayerInput_InputAdapter_instance;
function DeletePlayerInput_InputAdapter_getInstance() {
  return DeletePlayerInput_InputAdapter_instance;
}
//region block: init
DeletePlayerInput_InputAdapter_instance = new (DeletePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  DeletePlayerInput_InputAdapter_instance as DeletePlayerInput_InputAdapter_instance32le1wrat1tkn,
};
//endregion

//# sourceMappingURL=DeletePlayerInput_InputAdapter.mjs.map
